"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _merge = require("rxjs/observable/merge");

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _mergeMap = require("rxjs/operators/mergeMap");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _reduxObservable = require("redux-observable");

var _I18n = _interopRequireDefault(require("I18n"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _WorkspacesAPI = _interopRequireDefault(require("../api/WorkspacesAPI"));

var _WorkspaceActions = require("../actions/WorkspaceActions");

var _AppActions = require("../actions/AppActions");

var _getFailureBannerAction = _interopRequireDefault(require("./getFailureBannerAction"));

function removeTemporaryId(workspace) {
  return workspace.delete('id');
}

function extractIds(members, type) {
  return members.filter(function (member) {
    return member.memberType === type;
  }).map(function (member) {
    return member.id;
  });
}

var createWorkspace = function createWorkspace(action$) {
  return action$.ofType(_WorkspaceActions.WorkspaceActionTypes.CREATE_WORKSPACE).pipe((0, _mergeMap.mergeMap)(function (action) {
    var _action$payload = action.payload,
        workspace = _action$payload.workspace,
        authedUser = _action$payload.authedUser;
    return (0, _fromPromise.fromPromise)(_WorkspacesAPI.default.createWorkspace(removeTemporaryId(workspace))).pipe((0, _mergeMap.mergeMap)(function (response) {
      var bannerTitleMessage = (0, _unescapedText.default)('workspacesManager.success.createWorkspace', {
        name: workspace.name
      });
      return (0, _of.of)(_WorkspaceActions.CreateWorkspace.success({
        workspace: response,
        authedUser: authedUser
      }), (0, _AppActions.showSuccessBanner)(bannerTitleMessage, _I18n.default.t('workspacesManager.success.createWorkspaceBody')));
    }), (0, _catchError.catchError)(function (error) {
      return (0, _merge.merge)((0, _of.of)(_WorkspaceActions.CreateWorkspace.failure(error, action.payload)), (0, _of.of)((0, _getFailureBannerAction.default)(error, _I18n.default.t('workspacesManager.errors.sorry'), _I18n.default.t('workspacesManager.errors.unableToCreateWorkspace'))));
    }), (0, _startWith.startWith)(_WorkspaceActions.CreateWorkspace.request()));
  }));
};

var deleteWorkspace = function deleteWorkspace(action$) {
  return action$.ofType(_WorkspaceActions.WorkspaceActionTypes.DELETE_WORKSPACE).pipe((0, _mergeMap.mergeMap)(function (action) {
    var workspace = action.payload.workspace;
    return (0, _fromPromise.fromPromise)(_WorkspacesAPI.default.deleteWorkspace(workspace.id)).pipe((0, _mergeMap.mergeMap)(function () {
      return (0, _merge.merge)((0, _of.of)(_WorkspaceActions.DeleteWorkspace.success(workspace)), (0, _of.of)((0, _AppActions.showSuccessBanner)(null, _I18n.default.t('workspacesManager.success.deletedWorkspaceBody', {
        name: workspace.name
      }))));
    }), (0, _catchError.catchError)(function (error) {
      return (0, _merge.merge)((0, _of.of)(_WorkspaceActions.DeleteWorkspace.failure(error)), (0, _of.of)((0, _getFailureBannerAction.default)(error, _I18n.default.t('workspacesManager.errors.sorry'), _I18n.default.t('workspacesManager.errors.unableToDeleteWorkspace', {
        name: workspace.name
      }))));
    }), (0, _startWith.startWith)(_WorkspaceActions.DeleteWorkspace.request()));
  }));
};

var deleteWorkspaceMembers = function deleteWorkspaceMembers(action$) {
  return action$.ofType(_WorkspaceActions.WorkspaceActionTypes.DELETE_WORKSPACE_MEMBERS).pipe((0, _mergeMap.mergeMap)(function (action) {
    var _action$payload2 = action.payload,
        workspace = _action$payload2.workspace,
        members = _action$payload2.members;
    var userIds = extractIds(members, 'user');
    var teamIds = extractIds(members, 'team');
    var totalCount = userIds.size + teamIds.size;
    return (0, _fromPromise.fromPromise)(_WorkspacesAPI.default.deleteWorkspaceMembers(workspace.id, userIds, teamIds)).pipe((0, _mergeMap.mergeMap)(function (response) {
      return (0, _merge.merge)((0, _of.of)(_WorkspaceActions.DeleteWorkspaceMembers.success({
        workspace: response
      })), (0, _of.of)((0, _AppActions.showSuccessBanner)(null, _I18n.default.t('workspacesManager.success.deletedWorkspaceMembersBody', {
        name: workspace.name,
        count: totalCount
      }))));
    }), (0, _catchError.catchError)(function (error) {
      return (0, _merge.merge)((0, _of.of)(_WorkspaceActions.DeleteWorkspaceMembers.failure(error)), (0, _of.of)((0, _getFailureBannerAction.default)(error, _I18n.default.t('workspacesManager.errors.sorry'), _I18n.default.t('workspacesManager.errors.unableToDeleteWorkspaceMembers', {
        name: workspace.name
      }))));
    }), (0, _startWith.startWith)(_WorkspaceActions.DeleteWorkspaceMembers.request()));
  }));
};

var addWorkspaceMembers = function addWorkspaceMembers(action$) {
  return action$.ofType(_WorkspaceActions.WorkspaceActionTypes.ADD_WORKSPACE_MEMBERS).pipe((0, _mergeMap.mergeMap)(function (action) {
    var _action$payload3 = action.payload,
        workspace = _action$payload3.workspace,
        userIds = _action$payload3.userIds,
        teamIds = _action$payload3.teamIds;
    var totalCount = userIds.size + teamIds.size;
    return (0, _fromPromise.fromPromise)(_WorkspacesAPI.default.addWorkspaceMembers(workspace.id, userIds, teamIds)).pipe((0, _mergeMap.mergeMap)(function (response) {
      return (0, _merge.merge)((0, _of.of)(_WorkspaceActions.AddWorkspaceMembers.success({
        workspace: response
      })), (0, _of.of)((0, _AppActions.showSuccessBanner)(null, _I18n.default.t('workspacesManager.success.addWorkspaceMembersBody', {
        name: workspace.name,
        count: totalCount
      }))));
    }), (0, _catchError.catchError)(function (error) {
      return (0, _merge.merge)((0, _of.of)(_WorkspaceActions.AddWorkspaceMembers.failure(error)), (0, _of.of)((0, _getFailureBannerAction.default)(error, _I18n.default.t('workspacesManager.errors.sorry'), _I18n.default.t('workspacesManager.errors.unableToAddWorkspaceMembers', {
        name: workspace.name
      }))));
    }), (0, _startWith.startWith)(_WorkspaceActions.AddWorkspaceMembers.request()));
  }));
};

var editWorkspace = function editWorkspace(action$) {
  return action$.ofType(_WorkspaceActions.WorkspaceActionTypes.EDIT_WORKSPACE).pipe((0, _mergeMap.mergeMap)(function (action) {
    var _action$payload4 = action.payload,
        workspace = _action$payload4.workspace,
        authedUser = _action$payload4.authedUser;
    return (0, _fromPromise.fromPromise)(_WorkspacesAPI.default.updateWorkspace(workspace)).pipe((0, _mergeMap.mergeMap)(function (response) {
      return (0, _of.of)(_WorkspaceActions.EditWorkspace.success({
        workspace: response,
        authedUser: authedUser
      }), (0, _AppActions.showSuccessBanner)(null, _I18n.default.t('workspacesManager.success.editWorkspaceBody', {
        name: workspace.name
      })));
    }), (0, _catchError.catchError)(function (error) {
      return (0, _merge.merge)((0, _of.of)(_WorkspaceActions.EditWorkspace.failure(error, action.payload)), (0, _of.of)((0, _getFailureBannerAction.default)(error, _I18n.default.t('workspacesManager.errors.sorry'), _I18n.default.t('workspacesManager.errors.unableToEditWorkspace'))));
    }), (0, _startWith.startWith)(_WorkspaceActions.EditWorkspace.request()));
  }));
};

var _default = (0, _reduxObservable.combineEpics)(createWorkspace, deleteWorkspace, deleteWorkspaceMembers, addWorkspaceMembers, editWorkspace);

exports.default = _default;
module.exports = exports.default;